import { gql } from 'graphql-request';

import { requestWithAuth } from '@/utilities/graphQLClient';

import { WATCHLIST_FRAGMENT } from './watchlist-fragment';
import type { WatchlistFragmentType } from './watchlist-fragment';

type Response =
  | { errors: Error[] }
  | {
      Watchlists: (WatchlistFragmentType & {
        items: { companyId: string }[];
      })[];
    };

export const queryFn = async () => {
  const response = await requestWithAuth<Response>(gql`
    query getWatchlists {
      Watchlists {
        ...watchlistFields
        items {
          companyId
        }
      }
    }
    ${WATCHLIST_FRAGMENT}
  `);

  if ('Watchlists' in response) {
    return response.Watchlists;
  }

  const firstErrorMessage = response.errors[0]?.message;
  throw new Error(firstErrorMessage ?? 'Failed to fetch Watchlists');
};
